import styled from "styled-components";

export const EndAdornment = styled.div`
    margin-left: 10px;
`;
